<template>
  <select @change="change($event.target.value)">
    <option v-for="o in organizations" :key="o.id" :value="o.id" :selected="o.id == organizationId">
      {{ o.name }}
    </option>
  </select>
</template>

<script setup>
// Define props
defineProps({
  organizationId: [String, Number],
  organizations: Array,
});

// Emit event
const emit = defineEmits(["update:organizationId"]);

// Method to handle the change event
const change = id => {
  emit("update:organizationId", id);
};
</script>
